import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from 'environments/environment';

const BACKENDURL = environment.backendBaseURL;
const SUBSCRIPTION_URL = environment.subscriptionServiceBaseURL;
const SUBSCRIPTION_ENDPOINT = environment.subscriptionEndpoint;

@Injectable({
  providedIn: 'root',
})
export class BaseUrlInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (req.url.includes(SUBSCRIPTION_ENDPOINT)) {
      return next.handle(
        req.clone({
          url: `${SUBSCRIPTION_URL}${req.url}`,
        }),
      );
    } else if (environment.local || req.url.includes('/assets') || req.url.includes('storage.googleapis')) {
      return next.handle(
        req.clone({
          url: `${req.url}`,
        }),
      );
    } else {
      return next.handle(
        req.clone({
          url: `${BACKENDURL}/${req.url}`,
        }),
      );
    }
  }
}
